export default __webpack_public_path__ + "static/media/Res_Amazon-VPC_Endpoints_48_Light.3bb96609.svg";